import React, { Component } from 'react';
import Select from 'react-select';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const operatorOptions = [
  {
    value: 'lt',
    label: '<',
  },
  {
    value: 'lte',
    label: '<=',
  },
  {
    value: 'eq',
    label: '=',
  },
  {
    value: 'gte',
    label: '=>',
  },
  {
    value: 'gt',
    label: '>',
  },
  {
    value: 'ne',
    label: '!=',
  },
];
const customStyles = {
  control: (styles) => ({
    ...styles,
    height: '2.5rem',
    border: '1px solid #abadae',
    marginTop: '0.4rem',
    boxShadow: '0 1px 0 0 rgba(46, 50, 53, 0.1)',
    fontWeight: '400',
    textAlign: 'left',
  }),
  option: (provided) => ({
    ...provided,
    fontWeight: '400',
    textAlign: 'left',
  }),
};

export class AlertConfigurationConditions extends Component {
  render() {
    const {
      conditions,
      handleConditionTextChange,
      handleConditionTextBlur,
      onConditionSelectChange,
      dataTags,
      removeRow,
      validDataTags,
    } = this.props;

    return (
      <div>
        {conditions.map((condition, i) => {
          const { name, api_location, data_point_tag, comparison_operator, limit, rolling_average_minutes } = condition;

          const currentTag = dataTags.find((dataTag) => dataTag.slug === data_point_tag);
          const measurementUnit = currentTag ? currentTag.measurement_unit_display : '';

          return (
            <div key={i} className="alert-configuration__legend-item">
              <div className="alert-configuration__alert-condition-input-wrapper">
                <input
                  type="text"
                  id={`name${i}-input`}
                  className="alert-configuration__text-input"
                  name="name"
                  value={name}
                  onChange={(e) => handleConditionTextChange(i, e)}
                  onBlur={(e) => handleConditionTextBlur(i, api_location, e)}
                />
              </div>
              <div className="alert-configuration__alert-condition-input-wrapper">
                <Select
                  id={`tag${i}-select`}
                  options={validDataTags}
                  styles={customStyles}
                  className="alert-configuration__select-dropdown"
                  onChange={(selectedOption) => {
                    if (Array.isArray(selectedOption)) {
                      throw new Error('Unexpected type passed to ReactSelect onChange handler');
                    }

                    onConditionSelectChange(i, api_location, selectedOption.value, 'data_point_tag');
                  }}
                  defaultValue={validDataTags.find((dataTag) => {
                    return dataTag.value === data_point_tag;
                  })}
                />
              </div>
              <div className="alert-configuration__alert-condition-input-wrapper">
                <Select
                  id={`operator${i}-select`}
                  options={operatorOptions}
                  styles={customStyles}
                  className="alert-configuration__select-dropdown"
                  onChange={(selectedOption) => {
                    if (Array.isArray(selectedOption)) {
                      throw new Error('Unexpected type passed to ReactSelect onChange handler');
                    }

                    onConditionSelectChange(i, api_location, selectedOption.value, 'comparison_operator');
                  }}
                  defaultValue={operatorOptions.find((operation) => {
                    return operation.value === comparison_operator;
                  })}
                />
              </div>
              <div className="alert-configuration__alert-condition-input-wrapper">
                <input
                  type="text"
                  id={`limit${i}-input`}
                  className="alert-configuration__text-input"
                  name="limit"
                  value={limit}
                  onChange={(e) => handleConditionTextChange(i, e)}
                  onBlur={(e) => handleConditionTextBlur(i, api_location, e)}
                />
                <span className="alert-configuration__alert-condition-input-units desktop-only">{measurementUnit}</span>
              </div>
              <div className="alert-configuration__alert-condition-input-wrapper">
                <input
                  type="text"
                  id={`rolling_average_minutes${i}-input`}
                  className="alert-configuration__text-input"
                  name="rolling_average_minutes"
                  value={rolling_average_minutes}
                  onChange={(e) => handleConditionTextChange(i, e)}
                  onBlur={(e) => handleConditionTextBlur(i, api_location, e)}
                />
              </div>
              {/* <div className="alert-configuration__alert-condition-input-wrapper">
                <input
                  type="text"
                  id={`message${i}-input`}
                  className="alert-configuration__text-input"
                  name="message"
                  value={message}
                  onChange={(e) => handleConditionTextChange(i, e)}
                  onBlur={(e) => handleConditionTextBlur(i, api_location, e)}
                />
              </div> */}
              <div className="alert-configuration__alert-condition-input-wrapper">
                <div className="alert-configuration__alert-icon">
                  <span
                    className="alert-configuration__alert-condition-button"
                    onClick={() => removeRow(i, api_location)}
                  >
                    <FontAwesomeIcon icon={faTrash} size="lg" color="#0295a6" />
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}
